import { createSelector } from 'reselect'
import { getApp } from 'react-redux/selectors/app'

export default createSelector(
  [ getApp ],
  ( app) => {    
    return Object.assign(
      {},
      {
        cookieAllowed: app.cookieAllowed
      }
    )
  }
)



// WEBPACK FOOTER //
// ./src/app/component/cookie-opt-in/selector.js